import React from 'react';
import { func, number } from 'prop-types';
import debounce from 'lodash/debounce';
import Input from 'ps-components/Input/Input';
import './SkillDifferentialAdjustment.scss';

const MULTI_SELECTED_LABEL = 'Skills Selected';
const SINGLE_SELECTED_LABEL = 'Skill Selected';
const TOTAL_ADJ_LABEL = 'Total Applied Skill Differential';

class SkillDifferentialAdjustment extends React.Component {
  static propTypes = {
    count: number,
    totalAdjustment: number,
    totalAdjustmentOverride: number,
    updateTotalAdjustmentOverride: func
  };

  constructor(props) {
    super(props);

    this.state = {
      adjustmentOverride: this.formatAdjustment(props.totalAdjustment)
    };
  }

  componentDidUpdate(prevProps) {
    const { totalAdjustment, totalAdjustmentOverride } = this.props;

    if (prevProps.totalAdjustmentOverride !== totalAdjustmentOverride) {
      this.setState({
        adjustmentOverride: this.formatAdjustment(totalAdjustmentOverride)
      });
    }
    if (prevProps.totalAdjustment !== totalAdjustment) {
      this.setState({
        adjustmentOverride: this.formatAdjustment(totalAdjustment)
      });
    }
  }

  formatAdjustment = adjustment => {
    return `${(adjustment * 100).toFixed(1)}%`;
  };

  handleOverrideChange = event => {
    const displayValue = event.target.value;
    const value = displayValue.replace('%', '');

    this.setState({ adjustmentOverride: displayValue });
    this.updateAdjustmentOverride(value);
  };

  updateAdjustmentOverride = debounce(value => {
    const { updateTotalAdjustmentOverride } = this.props;
    if (!isNaN(value)) {
      const decimalValue = parseFloat((value * 0.01).toFixed(3));
      updateTotalAdjustmentOverride(decimalValue);
      this.setState({ adjustmentOverride: this.formatAdjustment(decimalValue) });
    }
  }, 750);

  render() {
    const { count } = this.props;
    const { adjustmentOverride } = this.state;

    return (
      <div className="card__footer-data">
        <div className="skills__count">
          {count && <span className="skills__count-number">{count}</span>}
          <span className="skills__count-label">{count === 1 ? SINGLE_SELECTED_LABEL : MULTI_SELECTED_LABEL}</span>
        </div>
        <div className="total__adj">
          <span className="total__adj-label">{TOTAL_ADJ_LABEL}</span>
          <Input
            className="adjustment__input"
            disabled={false}
            id="skill_adjustment"
            onChange={this.handleOverrideChange}
            type="text"
            value={adjustmentOverride}
          />
        </div>
      </div>
    );
  }
}

export default SkillDifferentialAdjustment;
